import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { receiptsTabChosen } from './receiptsSlice'
import type { ReceiptsActions } from './types'

/** Действия вкладок экрана чеков для binding: `{ ...base, ...createReceiptsTabActions(rid, dispatch) }`. */
export function createReceiptsTabActions(
  resourceId: string,
  dispatch: Dispatch<UnknownAction>,
): Required<Pick<ReceiptsActions, 'chooseTab'>> {
  return {
    chooseTab: (tab) => dispatch(receiptsTabChosen({ resourceId, tab })),
  }
}
